/**
 * Business update request DTO used to interact with backend
 */
export class BusinessUpdateRequestDTO {
  // prettier-ignore
  /**
   * @constructor
   */
  constructor( // NOSONAR
    public businessName?: string,
    public businessType?: string,
    public website?: string,
    public email?: string,
    public imgSource?: string,
    public addressNumber?: string,
    public postalCode?: string,
    public state?: string | any,
    public address?: string,
    public regionId?: number,
    public countryId?: number,
    public businessLevelId?: number,
    public phoneNumber?: string,
    public active?: boolean
  ) {}
}
